var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});
(function () {
  'use strict';

  if (window.__materea_cart_guard) return;
  window.__materea_cart_guard = true;

  var WURZEL = '[data-materea-cart-guard]';
  var CHECKOUT = '#checkout, [name="checkout"], .cart__checkout-button';
  var EXPRESS = '.additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"]';

  function alle(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function pflichtLuecke(zeile) {
    

    var p = zeile.properties || {};
    var fehlt = [];
    if (String(p['Unternehmerbuchung'] || '').toLowerCase() !== 'ja') {
      fehlt.push(materea_t("js.cart_guard.bestaetigung_betrieb"));
    }
    return fehlt;
  }

  function satzAus(teile) {
    if (teile.length === 1) return teile[0];
    return teile.slice(0, -1).join(', ') + materea_t("js.gemeinsam.und") + teile[teile.length - 1];
  }

   

  function schreibe(updates) {
    return fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/update.js", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('update fehlgeschlagen');
      window.location.reload();
    });
  }

  function mitLadezustand(knopf, arbeit) {
    var alt = knopf.textContent;
    knopf.disabled = true;
    knopf.textContent = materea_t("js.gemeinsam.einen_moment");
    arbeit().catch(function () {
      knopf.disabled = false;
      knopf.textContent = alt;
      var box = document.querySelector('[data-mcg-fehler]');
      if (box) {
        box.textContent = materea_t("js.cart_guard.fehler_neu_laden");
        box.hidden = false;
      }
    });
  }

   

  function zeilenKnoten(key) {
    return document.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
  }

  function mengenwahlAus(keys) {
    keys.forEach(function (key) {
      var knoten = zeilenKnoten(key);
      if (!knoten) return;
      alle('.quantity-selector, quantity-selector-component, .cart-items__quantity-controls > .volume-pricing-info', knoten)
        .forEach(function (el) { el.style.display = 'none'; });
      var zelle = knoten.querySelector('.cart-items__quantity');
      if (zelle && !zelle.querySelector('[data-mcg-platzzahl]')) {
        var span = document.createElement('span');
        span.setAttribute('data-mcg-platzzahl', '');
        span.style.cssText = 'font-size:13px;color:#5b5852;white-space:nowrap';
        span.textContent = materea_t("js.cart_guard.ein_platz");
        var ziel = knoten.querySelector('.cart-items__quantity-controls') || zelle;
        ziel.insertBefore(span, ziel.firstChild);
      }
    });
  }

  function checkoutSperren(gesperrt) {
    

    alle(CHECKOUT).forEach(function (el) {
      if (gesperrt) {
        if (!el.disabled) {
          el.disabled = true;
          el.setAttribute('aria-disabled', 'true');
          el.dataset.mcgGesperrt = '1';
        }
      } else if (el.dataset.mcgGesperrt) {
        el.disabled = false;
        el.removeAttribute('aria-disabled');
        delete el.dataset.mcgGesperrt;
      }
    });
    alle(EXPRESS).forEach(function (el) {
      if (gesperrt) {
        if (!el.hidden) {
          el.hidden = true;
          el.dataset.mcgVersteckt = '1';
        }
      } else if (el.dataset.mcgVersteckt) {
        el.hidden = false;
        delete el.dataset.mcgVersteckt;
      }
    });
  }

   

  function zeigeFall(wurzel, name) {
    alle('[data-mcg-fall]', wurzel).forEach(function (el) {
      el.hidden = el.getAttribute('data-mcg-fall') !== name;
    });
    wurzel.hidden = false;
  }

  function baueLuecken(wurzel, luecken) {
    var liste = wurzel.querySelector('[data-mcg-liste]');
    if (!liste) return;
    liste.textContent = '';
    luecken.forEach(function (l) {
      var li = document.createElement('li');
      li.className = 'mcg-zeile';

      var kopf = document.createElement('b');
      kopf.textContent = l.titel;
      li.appendChild(kopf);

      var grund = document.createElement('span');
      grund.className = 'mcg-grund';
      grund.textContent = ' ' + l.grund;
      li.appendChild(grund);

      var aktionen = document.createElement('div');
      aktionen.className = 'mcg-aktionen';

      if (l.zuruecksetzen) {
        var eins = document.createElement('button');
        eins.type = 'button';
        eins.className = 'mcg-cta';
        eins.textContent = materea_t("js.cart_guard.auf_einen_platz");
        eins.addEventListener('click', function () {
          mitLadezustand(eins, function () {
            var u = {};
            u[l.key] = 1;
            return schreibe(u);
          });
        });
        aktionen.appendChild(eins);
      }

      if (l.url) {
        var auf = document.createElement('a');
        auf.className = l.zuruecksetzen ? 'mcg-link' : 'mcg-cta';
        auf.href = l.url;
        auf.textContent = materea_t("js.cart_guard.termin_oeffnen");
        aktionen.appendChild(auf);
      }

      var weg = document.createElement('button');
      weg.type = 'button';
      weg.className = 'mcg-link';
      weg.textContent = materea_t("js.cart_guard.zeile_entfernen");
      weg.addEventListener('click', function () {
        mitLadezustand(weg, function () {
          var u = {};
          u[l.key] = 0;
          return schreibe(u);
        });
      });
      aktionen.appendChild(weg);

      li.appendChild(aktionen);
      liste.appendChild(li);
    });

    var titel = wurzel.querySelector('[data-mcg-angaben-titel]');
    if (titel) {
      titel.textContent = luecken.length === 1
        ? materea_t("js.cart_guard.eine_zeile_fehlt")
        : materea_t("js.cart_guard.zeilen_fehlen",{n:luecken.length});
    }
  }

   

  function pruefe() {
    var wurzel = document.querySelector(WURZEL);
    if (!wurzel) return;
    var frei = wurzel.getAttribute('data-frei') === 'true';
    var typ = (wurzel.getAttribute('data-workshop-typ') || 'Workshop').toLowerCase();

    fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart.js", { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var zeilen = cart.items || [];
        var workshops = zeilen.filter(function (z) {
          return String(z.product_type || '').toLowerCase() === typ;
        });
        var material = zeilen.filter(function (z) {
          return String(z.product_type || '').toLowerCase() !== typ;
        });

        mengenwahlAus(workshops.map(function (z) { return z.key; }));

        var luecken = [];
        workshops.forEach(function (z) {
          var fehlt = pflichtLuecke(z);
          var zuviel = z.quantity > 1;
          if (!fehlt.length && !zuviel) return;
          var grund;
          if (zuviel && fehlt.length) {
            grund = materea_t("js.cart_guard.grund_beides",{n:z.quantity,fehlt:satzAus(fehlt)});
          } else if (zuviel) {
            grund = materea_t("js.cart_guard.grund_zuviel",{n:z.quantity});
          } else {
            grund = materea_t("js.cart_guard.grund_fehlt",{fehlt:satzAus(fehlt)});
          }
          luecken.push({
            key: z.key,
            titel: (z.product_title || z.title) + (z.variant_title ? ', ' + z.variant_title : ''),
            grund: grund,
            zuruecksetzen: zuviel,
            url: z.url || null
          });
        });

        var mischkorb = material.length > 0 && workshops.length > 0 && !frei;
        var nurMaterial = material.length > 0 && workshops.length === 0 && !frei;

        if (luecken.length) {
          baueLuecken(wurzel, luecken);
          zeigeFall(wurzel, 'angaben');
          checkoutSperren(true);
        } else if (mischkorb) {
          zeigeFall(wurzel, 'mischkorb');
          checkoutSperren(true);
        } else if (nurMaterial) {
          zeigeFall(wurzel, 'material');
          checkoutSperren(true);
        } else {
          wurzel.hidden = true;
          checkoutSperren(false);
        }

        var raus = wurzel.querySelector('[data-mcg-material-raus]');
        if (raus && !raus.dataset.mcgVerdrahtet) {
          raus.dataset.mcgVerdrahtet = '1';
          raus.addEventListener('click', function () {
            mitLadezustand(raus, function () {
              var u = {};
              material.forEach(function (z) { u[z.key] = 0; });
              return schreibe(u);
            });
          });
        }
      })
      .catch(function () {
        

      });
  }

  function beobachte() {
    var ziel = document.querySelector('cart-items-component, .cart-items, [data-key]');
    if (!ziel) return;
    var behaelter = ziel.closest('cart-items-component, .cart-items, table, form') || ziel.parentNode;
    if (!behaelter) return;
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      setTimeout(function () { wartet = false; pruefe(); }, 120);
    }).observe(behaelter, { childList: true, subtree: true });
  }

  function start() {
    pruefe();
    beobachte();
    window.addEventListener('pageshow', pruefe);
    ['cart:update', 'cart-lines:update', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, pruefe);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
